<template>
  <div
    v-if="character"
    class="summary-root"
  >
    <div class="row gx-1 summary-grid">
      <div class="summary-section summary-section-chars">
        <SheetSummaryChars :character="character" />
      </div>
      <div class="summary-section summary-section-main">
        <SheetSummaryAbilities :character="character" />
      </div>
      <div class="summary-section summary-section-general">
        <SheetSummaryGeneral :character="character" />
      </div>
    </div>
  </div>
</template>

<script>
import SheetSummaryAbilities from './SheetSummaryAbilities.vue'
import SheetSummaryChars from './SheetSummaryChars.vue'
import SheetSummaryGeneral from './SheetSummaryGeneral.vue'

export default {
  name: 'SheetSummary',
  components: {
    SheetSummaryAbilities,
    SheetSummaryChars,
    SheetSummaryGeneral,
  },
  props: {
    character: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.summary-root {
  display: block;
  width: 60%;
  max-width: 60%;
}

.summary-grid {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}

.summary-section {
  flex: 0 0 auto;
  min-width: 0;
}

.summary-section-chars {
  width: 22%;
}

.summary-section-main {
  width: 37%;
}

.summary-section-general {
  width: 41%;
}
</style>
